export default "__VITE_ASSET__DQJUBpGh__"